import type { ImageLoader } from 'next/image'

export const EVOLVE_IMAGE_SRC_REGEX =
  /^https:\/\/images\.(?:staging\.)?evolve\.com\/(?:listings|uploads)\/[^/?#]+\/[^/?#]+(?:[?#]|$)/

const evolveImageLoader: ImageLoader = ({ src, width, quality }) => {
  const url = new URL(src)
  url.searchParams.set('width', String(width))
  url.searchParams.set('quality', String(quality || 85))
  return url.toString()
}

export default evolveImageLoader
